export default __webpack_public_path__ + "static/media/about-4.937780d1.png";